<style scoped>
.receipt {
  background-color: #fff;
  margin: 1.5rem .5rem;
  padding: 0;
}
.receipt .media {
  align-items: center;
  padding-right: 1rem;
}
.receipt .image.circle {
  margin: .5rem;
}
.receipt .c-content {
  flex-grow: 1;
}
.receipt .c-content .level {
  align-items: baseline;
}
.receipt .amount span {
  margin: 0 .5rem;
}
.receipt:before {
  content: '';
  display: block;
  position: relative;
  top: -.375rem;
  width: 100%;
  height: .5rem;
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 8"><path fill="white" d="M0 0L6 4L12 0L18 4L24 0V8L24 8L0 8V0Z" /></svg>');
  background-repeat: repeat;
}
.receipt:after {
  content: '';
  display: block;
  position: relative;
  top: .375rem;
  width: 100%;
  height: .5rem;
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 8"><path fill="white" d="M0 8L6 4L12 8L18 4L24 8V0L24 0L0 0V0Z" /></svg>');
  background-repeat: repeat;
}
</style>

<template>
  <li class="receipt">
    <router-link :to="{name: 'receipt', params: route}">
      <div class="media">
        <figure class="image circle is-64x64">
          <cachalog-img class="is-rounded" :type="'background'" :caption="cImage.caption"
            :full-path="cImage.full_path"
            :source="cImage.source"></cachalog-img>
        </figure>
        <div class="c-content is-cs-5 is-c-normal-text">
          <p class="has-text-weight-bold">{{ receipt.title }}</p>
          <div class="level is-mobile">
            <time>{{ created }}</time>
            <div class="amount"><span class="is-cs-1">{{ receipt.amount.toLocaleString() }}</span>円</div>
          </div>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
import { datestr } from '../common.js'
export default {
  props: ['receipt', 'route'],
  computed: {
    cImage () {
      return this.receipt.images && this.receipt.images[1] ? this.receipt.images[1] : {}
    },
    created () {
      return datestr(this.receipt.created.toDate(), 'Y/m/d H:i')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/receipt-list.vue